export const TOKEN = 'customer-token';

export const ROUTES = {
  SIGNIN: '/login',
  DASHBOARD: '/dashboard',
  AUTH: '/login',
};

export const STRIPE_PUBLISHABLE_KEY = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;

// export const STATES = ["NSW", "VIC", "WA", "QLD", "SA", "TS", "ACT","TAS"]
export const STATES = ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'];

export const POST_CODE_LENGTH = 4;

export const POST_CODE_DIGITS_PATTERN = /^\d+$/;

export const POST_CODE_PATTERN = new RegExp(`^\\d{${POST_CODE_LENGTH}}$`);

export const SUPPORTING_DOCUMENT_STATUS = {
  not_yet_started: 'Click to upload',
  not_yet_submitted: 'Not yet submitted',
  not_assigned_to_user: 'Pending',
  in_progress: 'Under review',
  completed: 'Satisfied',
};

export const SPECIAL_CONDITION_STATUS = {
  not_yet_started: 'Pending',
  in_progress: 'Pending',
  completed: 'Completed',
};

export const ORDERED_CRM_STATUS = [
  'application_in_progress',
  'assessment_ready',
  'workshopping_application',
  'conditional_offer',
  'supporting_documents',
  'unconditional_offer',
  'solicitor_instructed',
  'document_issued',
  'document_received',
  'settlement_booked',
  'loan_funded',
  'loan_repaid',
];
